import * as zod from 'zod';

export default zod.object({
  stdout: zod.string().default(''),
  // Used by CodeBlocksWidget to figure out if we have new output.
  stdoutTimestamp: zod.date().optional(),
});
